// GENERATED by scripts/gen-charter.deno.ts from std-charter.allowlist and
// every storybook that declares tags(). Do not edit; regenerate with:
//   deno run -A tento/tento-ui-js/scripts/gen-charter.deno.ts
// check-charter rule 7 fails when this file is stale.
import type { Storybook } from "./ui/storybook";
import type { StdCharter } from "./std-charter";
import { AccordionStoryBook } from "./components/accordion.example";
import { CoreScrollVerticalStoryBook } from "./components/adjacent/scroll-vertical.core.example";
import { AnchorStoryBook } from "./components/anchor.example";
import { CoreAnimatedPanelStoryBook } from "./components/animated-panel.core.example";
import { AspectRatioStoryBook } from "./components/aspect-ratio/aspect-ratio.example";
import { AvatarStoryBook } from "./components/avatar.example";
import { CoreBadgeStoryBook } from "./components/badge.core.example";
import { BannerStoryBook } from "./components/banner/banner.example";
import { BlockquoteStoryBook } from "./components/blockquote/blockquote.example";
import { BottomSheetStoryBook } from "./components/bottom-sheet/bottom-sheet.example";
import { BreadcrumbStoryBook } from "./components/breadcrumb/breadcrumb.example";
import { BrowserChromeStoryBook } from "./components/browser-chrome.example";
import { ButtonGroupRowStoryBook } from "./components/button-group-row.example";
import { ButtonStoryBook } from "./components/button/button.example";
import { CoreLoadingButtonStoryBook } from "./components/button/loading-button.core.example";
import { CoreSquareButtonStoryBook } from "./components/button/square-button.core.example";
import { CardStoryBook } from "./components/card/card.example";
import { CarouselIndicatorStoryBook } from "./components/carousel/carousel-indicator.example";
import { CarouselStoryBook } from "./components/carousel/carousel.example";
import { CheckboxListStoryBook } from "./components/checkbox-list/checkbox-list.example";
import { CoreChipRowStoryBook } from "./components/chip/chip-row.core.example";
import { ChipStoryBook } from "./components/chip/chip.example";
import { CitationStoryBook } from "./components/citation/citation.example";
import { ClampBoxStoryBook } from "./components/clamp-box/clamp-box.example";
import { CoreCodeStoryBook } from "./components/code/code.core.example";
import { CodeMirrorStoryBook } from "./components/codemirror.example";
import { ContextMenuStoryBook } from "./components/context-menu.example";
import { ContextMeterStoryBook } from "./components/context-meter.example";
import { CheckboxCellStoryBook, CheckboxStoryBook } from "./components/controls/checkbox.example";
import { DatePickerStoryBook } from "./components/controls/date-picker.example";
import { DropdownStoryBook } from "./components/controls/dropdown.example";
import { InlineSelectStoryBook } from "./components/controls/inline-select.example";
import { CorePillSelectStoryBook } from "./components/controls/pill-select.core.example";
import { SliderStoryBook, ThickSliderStoryBook } from "./components/controls/slider.example";
import { SwitchStoryBook } from "./components/controls/switch.example";
import { CoreTimePickerStoryBook } from "./components/controls/time-picker.core.example";
import { ThickTwoWaySliderStoryBook, TwoWaySliderStoryBook } from "./components/controls/two-way-slider.example";
import { AvatarEditableStoryBook } from "./components/core/avatar-editable.example";
import { CoreJsonViewerStoryBook } from "./components/data/json-viewer.core.example";
import { DateRangeInputStoryBook } from "./components/date-range-input/date-range-input.example";
import { DiagnosticStoryBook } from "./components/diagnostic.example";
import { DialogStoryBook } from "./components/dialog/dialog.example";
import { CoreDisclaimerStoryBook } from "./components/disclaimer.core.example";
import { DividerLineStoryBook } from "./components/divider-line/divider-line.example";
import { DrawerStoryBook } from "./components/drawer.example";
import { EditableTextStoryBook } from "./components/editable-text.example";
import { EmptyStateStoryBook } from "./components/empty-state/empty-state.example";
import { ExceptionTraceStoryBook } from "./components/exception/exception-trace.example";
import { ExceptionStoryBook } from "./components/exception/exception.example";
import { FacepileStoryBook } from "./components/facepile.example";
import { FileInputStoryBook } from "./components/file-input/file-input.example";
import { FlippableCardStoryBook } from "./components/flippable-card.example";
import { FlowContainerStoryBook } from "./components/flow-container.example";
import { FractionLabelStoryBook } from "./components/fraction-label.example";
import { GridLayoutStoryBook } from "./components/grid/grid-layout.example";
import { HeroLayoutStoryBook } from "./components/hero-layout/hero-layout.example";
import { HoverCardStoryBook } from "./components/hover-card/hover-card.example";
import { HtmlEditorStoryBook } from "./components/html-editor.example";
import { IconButtonStoryBook } from "./components/icon-button.example";
import { IconStoryBook } from "./components/icon/icon.example";
import { CardIconStoryBook } from "./components/icons/card-icon.example";
import { ChartIconStoryBook } from "./components/icons/chart-icon.example";
import { ChatIconStoryBook } from "./components/icons/chat-icon.example";
import { GlobeIconStoryBook } from "./components/icons/globe-icon.example";
import { HeartIconStoryBook } from "./components/icons/heart-icon.example";
import { LinkIconStoryBook } from "./components/icons/link-icon.example";
import { PomodoroIconStoryBook } from "./components/icons/pomodoro-icon.example";
import { SearchIconStoryBook } from "./components/icons/search-icon.example";
import { SheetsIconStoryBook } from "./components/icons/sheets-icon.example";
import { StickerIconStoryBook } from "./components/icons/sticker-icon.example";
import { TasksIconStoryBook } from "./components/icons/tasks-icon.example";
import { ThemePickerIconStoryBook } from "./components/icons/theme-picker-icon.example";
import { TildeIconStoryBook } from "./components/icons/tilde-icon.example";
import { LazyImageStoryBook } from "./components/image/lazy-image.example";
import { InputGroupStoryBook } from "./components/input-group/input-group.example";
import { CodeInputStoryBook } from "./components/input/code-input.example";
import { CoreColorFieldStoryBook } from "./components/input/color-field.core.example";
import { ColorInputStoryBook } from "./components/input/color-input.example";
import { DateFieldStoryBook } from "./components/input/date-field.example";
import { DateInputStoryBook } from "./components/input/date-input.example";
import { DatePickerInputStoryBook } from "./components/input/date-picker-input.example";
import { CoreDatePickerModalStoryBook } from "./components/input/date-picker-modal.core.example";
import { DateTimeRegionInputStoryBook } from "./components/input/datetimeregion-input.example";
import { CoreDropdownInputStoryBook } from "./components/input/dropdown-input.core.example";
import { FormStoryBook } from "./components/input/form.example";
import { HtmlEditorInputStoryBook } from "./components/input/html-editor-input.example";
import { CoreHtmlEditorModalStoryBook } from "./components/input/html-editor-modal.core.example";
import { InputLayoutStoryBook } from "./components/input/input-layout.example";
import { NumberInputAccessoryStoryBook } from "./components/input/number-input-accessory.example";
import { CoreNumberInputStoryBook } from "./components/input/number-input.core.example";
import { PropertyListStoryBook } from "./components/input/property-list.example";
import { CoreRadioButtonStoryBook } from "./components/input/radio-button.core.example";
import { SelectInputStoryBook } from "./components/input/select-input.example";
import { SliderInputStoryBook } from "./components/input/slider-input.example";
import { TextAlignmentInputStoryBook } from "./components/input/text-alignment-input.example";
import { TextInputMenubarStoryBook } from "./components/input/text-input-menubar.example";
import { TextInputStoryBook } from "./components/input/text-input.example";
import { TimeFieldStoryBook } from "./components/input/time-field.example";
import { TimeInputStoryBook } from "./components/input/time-input.example";
import { KbdStoryBook } from "./components/kbd/kbd.example";
import { LibraryCollectionLayoutStoryBook } from "./components/library/library-collection-layout.example";
import { LibraryFilterSortRowStoryBook } from "./components/library/library-filter-sort-row.example";
import { LibraryItemPresentationStoryBook } from "./components/library/library-item-presentation.example";
import { LibraryPageShellStoryBook } from "./components/library/library-page-shell.example";
import { LibrarySearchMountStoryBook } from "./components/library/library-search-mount.example";
import { LibraryToolbarStoryBook } from "./components/library/library-toolbar.example";
import { LightboxStoryBook } from "./components/lightbox/lightbox.example";
import { LinkEditPopoverStoryBook } from "./components/link-edit-popover.example";
import { LinkTextStoryBook } from "./components/link-text/link-text.example";
import { CoreListCellLayoutStoryBook } from "./components/list/list-cell-layout.core.example";
import { ListStoryBook } from "./components/list/list.example";
import { MarkdownStoryBook } from "./components/markdown/markdown.example";
import { MenuBarStoryBook } from "./components/menu-bar/menu-bar.example";
import { MiniWindowStoryBook } from "./components/mini-window.example";
import { CoreModalCloseButtonStoryBook } from "./components/modal-close-button/modal-close-button.core.example";
import { MultiSelectStoryBook } from "./components/multi-select/multi-select.example";
import { NumberFieldStoryBook } from "./components/number-field/number-field.example";
import { OutlineStoryBook } from "./components/outline/outline.example";
import { OverflowListStoryBook } from "./components/overflow-list/overflow-list.example";
import { PageIndicatorDotsStoryBook } from "./components/page-indicator-dots.example";
import { PaginationStoryBook } from "./components/pagination/pagination.example";
import { PillButtonStoryBook } from "./components/pill-button.example";
import { PillTextInputStoryBook } from "./components/pill-text-input.example";
import { PlotStoryBook } from "./components/plot.example";
import { PopoverStoryBook } from "./components/popover/popover.example";
import { ProgressBarStoryBook } from "./components/progress-bar/progress-bar.example";
import { PromptAlertStoryBook, PromptStoryBook } from "./components/prompt.example";
import { ProseMirrorStoryBook } from "./components/prosemirror.example";
import { RadioButtonCellStoryBook } from "./components/radio-button-cell.example";
import { RadioListStoryBook } from "./components/radio-list/radio-list.example";
import { CoreRailNavStoryBook } from "./components/rail/rail-nav.core.example";
import { CoreRailSectionStoryBook } from "./components/rail/rail-section.core.example";
import { CoreRailStoryBook } from "./components/rail/rail.core.example";
import { RecordHeaderStoryBook } from "./components/record-header.example";
import { ResizeHandleStoryBook } from "./components/resize-handle/resize-handle.example";
import { SectionTabsStoryBook } from "./components/review/section-tabs.example";
import { RichTextEditorStoryBook } from "./components/rich-text-editor/rich-text-editor.example";
import { RoundStoryBook } from "./components/round.example";
import { CartesianCoordinateStoryBook } from "./components/scroll/cartesian-coordinate.example";
import { ScrollHorizontalStoryBook } from "./components/scroll/scroll-horizontal.example";
import { ScrollLayoutSnapshotOverlayStoryBook } from "./components/scroll/scroll-layout-snapshot-overlay.example";
import { SectionHeadStoryBook } from "./components/section-head.example";
import { SegmentedControlStoryBook } from "./components/segmented-control/segmented-control.example";
import { SettingsBodyStoryBook, SettingsRowStoryBook, SettingsSectionStoryBook, SettingsSummaryStoryBook } from "./components/settings/settings.core.example";
import { AppBarStoryBook } from "./components/shell-layout/app-bar.example";
import { SideNavStoryBook } from "./components/side-nav/side-nav.example";
import { CoreSidebarActionBarStoryBook } from "./components/sidebar/sidebar-action-bar.core.example";
import { SidebarContainerStoryBook } from "./components/sidebar/sidebar-container.example";
import { SidebarExpandButtonStoryBook } from "./components/sidebar/sidebar-expand-button.example";
import { CoreSidebarSectionContainerStoryBook } from "./components/sidebar/sidebar-section-container.core.example";
import { CoreSidebarSectionNavStoryBook } from "./components/sidebar/sidebar-section-nav.core.example";
import { CoreSidebarSectionStoryBook } from "./components/sidebar/sidebar-section.core.example";
import { SkeletonStoryBook } from "./components/skeleton/skeleton.example";
import { SpinnerStoryBook } from "./components/spinner/spinner.example";
import { SplitButtonsStoryBook } from "./components/split-buttons/split-buttons.example";
import { SpotlightLayoutStoryBook } from "./components/spotlight/spotlight-layout.example";
import { CoreSpotlightRowStoryBook } from "./components/spotlight/spotlight-row.core.example";
import { SquircleStoryBook } from "./components/squircle/squircle.example";
import { StatusMarkStoryBook } from "./components/status/status-mark.example";
import { CoreStepperHorizontalStoryBook } from "./components/stepper.core.example";
import { StepperStoryBook } from "./components/stepper.example";
import { SwatchRowStoryBook } from "./components/swatch-row/swatch-row.example";
import { TableFooterStoryBook } from "./components/table/table-footer.example";
import { TableStoryBook } from "./components/table/table.example";
import { TextAreaStoryBook } from "./components/text-area/text-area.example";
import { ThemeContextStoryBook } from "./components/theme-context/theme-context.example";
import { ThumbnailStoryBook } from "./components/thumbnail/thumbnail.example";
import { TimestampStoryBook } from "./components/timestamp/timestamp.example";
import { ToastStoryBook } from "./components/toast/toast.example";
import { CoreToasterPersistentContainerStoryBook, CoreToasterStoryBook } from "./components/toast/toaster.core.example";
import { ToggleButtonGroupStoryBook } from "./components/toggle-button/toggle-button-group.example";
import { ToggleButtonStoryBook } from "./components/toggle-button/toggle-button.example";
import { TokenInputStoryBook } from "./components/token/token-input.example";
import { TokenStoryBook } from "./components/token/token.example";
import { ToolbarStoryBook } from "./components/toolbar/toolbar.example";
import { TooltipStoryBook } from "./components/tooltip/tooltip.example";
import { TopNavStoryBook } from "./components/top-nav/top-nav.example";
import { TransitionStoryBook } from "./components/transition.example";
import { TreeListStoryBook } from "./components/tree-list/tree-list.example";
import { TypeaheadStoryBook } from "./components/typeahead/typeahead.example";
import { VisuallyHiddenStoryBook } from "./components/visually-hidden/visually-hidden.example";

export namespace StdCharterGen {
  export type Tag = { tag: string; category: StdCharter.Category };
  export type Story = {
    make: () => Storybook;
    /** Primary first — the card is placed by tags[0]. */
    tags: string[];
    /** Repo-relative, the form `<std-storybook-card example=…>` takes. */
    example: string;
    className: string;
  };

  /** Every std- line of the allowlist, in file order. */
  export const TAGS: readonly Tag[] = [
    { tag: "std-accordion", category: "container" },
    { tag: "std-anchor", category: "action" },
    { tag: "std-animated-panel", category: "container" },
    { tag: "std-app-bar", category: "layout" },
    { tag: "std-apple-slider", category: "form-controls" },
    { tag: "std-aspect-ratio", category: "layout" },
    { tag: "std-avatar", category: "content" },
    { tag: "std-avatar-editable-badge", category: "content" },
    { tag: "std-badge", category: "feedback-status" },
    { tag: "std-banner", category: "feedback-status" },
    { tag: "std-blockquote", category: "content" },
    { tag: "std-bottom-sheet", category: "overlay" },
    { tag: "std-breadcrumb", category: "navigation" },
    { tag: "std-browser-chrome", category: "container" },
    { tag: "std-button", category: "action" },
    { tag: "std-button-group-row", category: "action" },
    { tag: "std-calendar-icon", category: "content" },
    { tag: "std-card", category: "container" },
    { tag: "std-carousel", category: "container" },
    { tag: "std-carousel-indicator", category: "container" },
    { tag: "std-cc", category: "content" },
    { tag: "std-cc-axis", category: "content" },
    { tag: "std-cc-line", category: "content" },
    { tag: "std-cc-point", category: "content" },
    { tag: "std-cc-segment", category: "content" },
    { tag: "std-chart-icon", category: "content" },
    { tag: "std-chat-codex-turn", category: "chat" },
    { tag: "std-chat-icon", category: "content" },
    { tag: "std-checkbox", category: "form-controls" },
    { tag: "std-checkbox-cell", category: "form-controls" },
    { tag: "std-checkbox-list", category: "form-controls" },
    { tag: "std-chip", category: "content" },
    { tag: "std-chip-row", category: "content" },
    { tag: "std-citation", category: "content" },
    { tag: "std-clamp-box", category: "container" },
    { tag: "std-code", category: "content" },
    { tag: "std-code-input", category: "form-controls" },
    { tag: "std-codemirror", category: "content" },
    { tag: "std-color-field", category: "form-controls" },
    { tag: "std-color-input", category: "form-controls" },
    { tag: "std-context-menu-anchor", category: "action" },
    { tag: "std-context-meter", category: "feedback-status" },
    { tag: "std-date-field", category: "form-controls" },
    { tag: "std-date-field-dropdown", category: "form-controls" },
    { tag: "std-date-input", category: "form-controls" },
    { tag: "std-date-picker", category: "form-controls" },
    { tag: "std-date-picker-input", category: "form-controls" },
    { tag: "std-date-picker-modal", category: "overlay" },
    { tag: "std-date-range-input", category: "form-controls" },
    { tag: "std-datetimeregion-input", category: "form-controls" },
    { tag: "std-diagnostic", category: "feedback-status" },
    { tag: "std-dialog", category: "overlay" },
    { tag: "std-disclaimer", category: "content" },
    { tag: "std-divider", category: "layout" },
    { tag: "std-drawer", category: "overlay" },
    { tag: "std-dropdown", category: "form-controls" },
    { tag: "std-dropdown-container", category: "form-controls" },
    { tag: "std-dropdown-input", category: "form-controls" },
    { tag: "std-editable-avatar", category: "content" },
    { tag: "std-editable-text", category: "content" },
    { tag: "std-empty-state", category: "feedback-status" },
    { tag: "std-exception", category: "feedback-status" },
    { tag: "std-exception-trace", category: "feedback-status" },
    { tag: "std-facepile", category: "content" },
    { tag: "std-file-input", category: "form-controls" },
    { tag: "std-flippable-card", category: "container" },
    { tag: "std-flow-container", category: "layout" },
    { tag: "std-form", category: "form-controls" },
    { tag: "std-fraction-label", category: "content" },
    { tag: "std-globe-icon", category: "content" },
    { tag: "std-grid-layout", category: "layout" },
    { tag: "std-heart-icon", category: "content" },
    { tag: "std-hero-layout", category: "layout" },
    { tag: "std-hero-layout-item", category: "layout" },
    { tag: "std-hover-card", category: "overlay" },
    { tag: "std-html-editor", category: "content" },
    { tag: "std-html-editor-input", category: "form-controls" },
    { tag: "std-html-editor-modal", category: "overlay" },
    { tag: "std-icon", category: "content" },
    { tag: "std-icon-button", category: "action" },
    { tag: "std-inline-select", category: "form-controls" },
    { tag: "std-inline-select-panel", category: "form-controls" },
    { tag: "std-input-group", category: "form-controls" },
    { tag: "std-input-layout", category: "form-controls" },
    { tag: "std-json-viewer", category: "content" },
    { tag: "std-kbd", category: "utility" },
    { tag: "std-lazy-image", category: "content" },
    { tag: "std-legend-tree", category: "table-list" },
    { tag: "std-library-filter-sort-row", category: "table-list" },
    { tag: "std-library-toolbar", category: "navigation" },
    { tag: "std-lightbox", category: "overlay" },
    { tag: "std-link", category: "action" },
    { tag: "std-link-edit-popover", category: "overlay" },
    { tag: "std-link-icon", category: "content" },
    { tag: "std-list", category: "table-list" },
    { tag: "std-list-cell-layout", category: "table-list" },
    { tag: "std-loading-button", category: "action" },
    { tag: "std-markdown", category: "content" },
    { tag: "std-menu-bar", category: "action" },
    { tag: "std-mini-window", category: "overlay" },
    { tag: "std-modal-close-button", category: "action" },
    { tag: "std-multi-select", category: "form-controls" },
    { tag: "std-number-field", category: "form-controls" },
    { tag: "std-number-input", category: "form-controls" },
    { tag: "std-number-input-accessory", category: "form-controls" },
    { tag: "std-outline", category: "navigation" },
    { tag: "std-overflow-list", category: "table-list" },
    { tag: "std-page-indicator-dots", category: "navigation" },
    { tag: "std-pagination", category: "navigation" },
    { tag: "std-pill-button", category: "action" },
    { tag: "std-pill-select", category: "form-controls" },
    { tag: "std-pill-text-input", category: "form-controls" },
    { tag: "std-plot", category: "content" },
    { tag: "std-plot-tooltip", category: "content" },
    { tag: "std-pomodoro-icon", category: "content" },
    { tag: "std-popover", category: "overlay" },
    { tag: "std-progress-bar", category: "feedback-status" },
    { tag: "std-prompt", category: "overlay" },
    { tag: "std-prompt-alert", category: "overlay" },
    { tag: "std-prompt-layout", category: "overlay" },
    { tag: "std-property-list", category: "table-list" },
    { tag: "std-property-list-item", category: "table-list" },
    { tag: "std-prosemirror", category: "content" },
    { tag: "std-radio-button", category: "form-controls" },
    { tag: "std-radio-button-cell", category: "form-controls" },
    { tag: "std-radio-list", category: "form-controls" },
    { tag: "std-rail", category: "layout" },
    { tag: "std-rail-section", category: "navigation" },
    { tag: "std-record-header", category: "content" },
    { tag: "std-resize-handle", category: "layout" },
    { tag: "std-rich-text-editor", category: "content" },
    { tag: "std-round", category: "container" },
    { tag: "std-scroll-horizontal", category: "layout" },
    { tag: "std-scroll-layout-snapshot-overlay", category: "layout" },
    { tag: "std-scroll-vertical", category: "layout" },
    { tag: "std-search-icon", category: "content" },
    { tag: "std-section-head", category: "content" },
    { tag: "std-section-tabs", category: "navigation" },
    { tag: "std-segmented-control", category: "form-controls" },
    { tag: "std-select-input", category: "form-controls" },
    { tag: "std-session-replay", category: "content" },
    { tag: "std-sheets-icon", category: "content" },
    { tag: "std-side-nav", category: "navigation" },
    { tag: "std-sidebar-action-bar", category: "navigation" },
    { tag: "std-sidebar-container", category: "layout" },
    { tag: "std-sidebar-expand-button", category: "navigation" },
    { tag: "std-sidebar-section", category: "navigation" },
    { tag: "std-sidebar-section-container", category: "navigation" },
    { tag: "std-sidebar-section-nav", category: "navigation" },
    { tag: "std-skeleton", category: "feedback-status" },
    { tag: "std-slider-input", category: "form-controls" },
    { tag: "std-spinner", category: "feedback-status" },
    { tag: "std-split-buttons", category: "action" },
    { tag: "std-spotlight-layout", category: "overlay" },
    { tag: "std-spotlight-row", category: "overlay" },
    { tag: "std-square-button", category: "action" },
    { tag: "std-squircle", category: "container" },
    { tag: "std-status-mark", category: "feedback-status" },
    { tag: "std-stepper", category: "navigation" },
    { tag: "std-stepper-horizontal", category: "navigation" },
    { tag: "std-sticker-icon", category: "content" },
    { tag: "std-swatch-row", category: "content" },
    { tag: "std-switch", category: "form-controls" },
    { tag: "std-table", category: "table-list" },
    { tag: "std-table-body", category: "table-list" },
    { tag: "std-table-body-row", category: "table-list" },
    { tag: "std-table-footer", category: "table-list" },
    { tag: "std-table-header", category: "table-list" },
    { tag: "std-table-header-column", category: "table-list" },
    { tag: "std-tasks-icon", category: "content" },
    { tag: "std-text-alignment-input", category: "form-controls" },
    { tag: "std-text-area", category: "form-controls" },
    { tag: "std-text-input", category: "form-controls" },
    { tag: "std-text-input-menubar", category: "form-controls" },
    { tag: "std-theme-context", category: "utility" },
    { tag: "std-theme-picker-icon", category: "content" },
    { tag: "std-thick-slider", category: "form-controls" },
    { tag: "std-thick-two-way-slider", category: "form-controls" },
    { tag: "std-thumbnail", category: "content" },
    { tag: "std-tilde-icon", category: "content" },
    { tag: "std-time-field", category: "form-controls" },
    { tag: "std-time-field-dropdown", category: "form-controls" },
    { tag: "std-time-input", category: "form-controls" },
    { tag: "std-time-picker", category: "form-controls" },
    { tag: "std-timestamp", category: "content" },
    { tag: "std-toast", category: "feedback-status" },
    { tag: "std-toaster", category: "feedback-status" },
    { tag: "std-toaster-persistent-container", category: "feedback-status" },
    { tag: "std-toggle-button", category: "form-controls" },
    { tag: "std-toggle-button-group", category: "form-controls" },
    { tag: "std-token", category: "form-controls" },
    { tag: "std-token-input", category: "form-controls" },
    { tag: "std-toolbar", category: "action" },
    { tag: "std-tooltip", category: "overlay" },
    { tag: "std-top-nav", category: "navigation" },
    { tag: "std-transition", category: "utility" },
    { tag: "std-tree-list", category: "table-list" },
    { tag: "std-two-way-slider", category: "form-controls" },
    { tag: "std-typeahead", category: "form-controls" },
    { tag: "std-visually-hidden", category: "utility" },
    { tag: "std-rail-nav", category: "navigation" },
    { tag: "std-library-collection-layout", category: "layout" },
    { tag: "std-library-page-shell", category: "layout" },
    { tag: "std-library-search-mount", category: "layout" },
    { tag: "std-library-item-presentation", category: "overlay" },
    { tag: "std-settings-body", category: "layout" },
    { tag: "std-settings-code", category: "content" },
    { tag: "std-settings-section", category: "container" },
    { tag: "std-settings-row", category: "container" },
    { tag: "std-settings-summary", category: "content" },
    { tag: "std-branch-graph", category: "table-list" },
    { tag: "std-item-list", category: "table-list" },
    { tag: "std-item-row", category: "table-list" },
  ];

  /** Every core story, in example-path order. */
  export const STORIES: readonly Story[] = [
    {
      make: () => new AccordionStoryBook(),
      tags: ["std-accordion"],
      example: "tento-ui-js/components/accordion.example.ts",
      className: "AccordionStoryBook",
    },
    {
      make: () => new CoreScrollVerticalStoryBook(),
      tags: ["std-scroll-vertical"],
      example: "tento-ui-js/components/adjacent/scroll-vertical.core.example.ts",
      className: "CoreScrollVerticalStoryBook",
    },
    {
      make: () => new AnchorStoryBook(),
      tags: ["std-anchor"],
      example: "tento-ui-js/components/anchor.example.ts",
      className: "AnchorStoryBook",
    },
    {
      make: () => new CoreAnimatedPanelStoryBook(),
      tags: ["std-animated-panel"],
      example: "tento-ui-js/components/animated-panel.core.example.ts",
      className: "CoreAnimatedPanelStoryBook",
    },
    {
      make: () => new AspectRatioStoryBook(),
      tags: ["std-aspect-ratio"],
      example: "tento-ui-js/components/aspect-ratio/aspect-ratio.example.ts",
      className: "AspectRatioStoryBook",
    },
    {
      make: () => new AvatarStoryBook(),
      tags: ["std-avatar"],
      example: "tento-ui-js/components/avatar.example.ts",
      className: "AvatarStoryBook",
    },
    {
      make: () => new CoreBadgeStoryBook(),
      tags: ["std-badge"],
      example: "tento-ui-js/components/badge.core.example.ts",
      className: "CoreBadgeStoryBook",
    },
    {
      make: () => new BannerStoryBook(),
      tags: ["std-banner"],
      example: "tento-ui-js/components/banner/banner.example.ts",
      className: "BannerStoryBook",
    },
    {
      make: () => new BlockquoteStoryBook(),
      tags: ["std-blockquote"],
      example: "tento-ui-js/components/blockquote/blockquote.example.ts",
      className: "BlockquoteStoryBook",
    },
    {
      make: () => new BottomSheetStoryBook(),
      tags: ["std-bottom-sheet"],
      example: "tento-ui-js/components/bottom-sheet/bottom-sheet.example.ts",
      className: "BottomSheetStoryBook",
    },
    {
      make: () => new BreadcrumbStoryBook(),
      tags: ["std-breadcrumb"],
      example: "tento-ui-js/components/breadcrumb/breadcrumb.example.ts",
      className: "BreadcrumbStoryBook",
    },
    {
      make: () => new BrowserChromeStoryBook(),
      tags: ["std-browser-chrome"],
      example: "tento-ui-js/components/browser-chrome.example.ts",
      className: "BrowserChromeStoryBook",
    },
    {
      make: () => new ButtonGroupRowStoryBook(),
      tags: ["std-button-group-row"],
      example: "tento-ui-js/components/button-group-row.example.ts",
      className: "ButtonGroupRowStoryBook",
    },
    {
      make: () => new ButtonStoryBook(),
      tags: ["std-button"],
      example: "tento-ui-js/components/button/button.example.ts",
      className: "ButtonStoryBook",
    },
    {
      make: () => new CoreLoadingButtonStoryBook(),
      tags: ["std-loading-button"],
      example: "tento-ui-js/components/button/loading-button.core.example.ts",
      className: "CoreLoadingButtonStoryBook",
    },
    {
      make: () => new CoreSquareButtonStoryBook(),
      tags: ["std-square-button"],
      example: "tento-ui-js/components/button/square-button.core.example.ts",
      className: "CoreSquareButtonStoryBook",
    },
    {
      make: () => new CardStoryBook(),
      tags: ["std-card"],
      example: "tento-ui-js/components/card/card.example.ts",
      className: "CardStoryBook",
    },
    {
      make: () => new CarouselIndicatorStoryBook(),
      tags: ["std-carousel-indicator"],
      example: "tento-ui-js/components/carousel/carousel-indicator.example.ts",
      className: "CarouselIndicatorStoryBook",
    },
    {
      make: () => new CarouselStoryBook(),
      tags: ["std-carousel"],
      example: "tento-ui-js/components/carousel/carousel.example.ts",
      className: "CarouselStoryBook",
    },
    {
      make: () => new CheckboxListStoryBook(),
      tags: ["std-checkbox-list"],
      example: "tento-ui-js/components/checkbox-list/checkbox-list.example.ts",
      className: "CheckboxListStoryBook",
    },
    {
      make: () => new CoreChipRowStoryBook(),
      tags: ["std-chip-row"],
      example: "tento-ui-js/components/chip/chip-row.core.example.ts",
      className: "CoreChipRowStoryBook",
    },
    {
      make: () => new ChipStoryBook(),
      tags: ["std-chip"],
      example: "tento-ui-js/components/chip/chip.example.ts",
      className: "ChipStoryBook",
    },
    {
      make: () => new CitationStoryBook(),
      tags: ["std-citation"],
      example: "tento-ui-js/components/citation/citation.example.ts",
      className: "CitationStoryBook",
    },
    {
      make: () => new ClampBoxStoryBook(),
      tags: ["std-clamp-box"],
      example: "tento-ui-js/components/clamp-box/clamp-box.example.ts",
      className: "ClampBoxStoryBook",
    },
    {
      make: () => new CoreCodeStoryBook(),
      tags: ["std-code"],
      example: "tento-ui-js/components/code/code.core.example.ts",
      className: "CoreCodeStoryBook",
    },
    {
      make: () => new CodeMirrorStoryBook(),
      tags: ["std-codemirror"],
      example: "tento-ui-js/components/codemirror.example.ts",
      className: "CodeMirrorStoryBook",
    },
    {
      make: () => new ContextMenuStoryBook(),
      tags: ["std-context-menu-anchor"],
      example: "tento-ui-js/components/context-menu.example.ts",
      className: "ContextMenuStoryBook",
    },
    {
      make: () => new ContextMeterStoryBook(),
      tags: ["std-context-meter"],
      example: "tento-ui-js/components/context-meter.example.ts",
      className: "ContextMeterStoryBook",
    },
    {
      make: () => new CheckboxStoryBook(),
      tags: ["std-checkbox"],
      example: "tento-ui-js/components/controls/checkbox.example.ts",
      className: "CheckboxStoryBook",
    },
    {
      make: () => new CheckboxCellStoryBook(),
      tags: ["std-checkbox-cell"],
      example: "tento-ui-js/components/controls/checkbox.example.ts",
      className: "CheckboxCellStoryBook",
    },
    {
      make: () => new DatePickerStoryBook(),
      tags: ["std-date-picker"],
      example: "tento-ui-js/components/controls/date-picker.example.ts",
      className: "DatePickerStoryBook",
    },
    {
      make: () => new DropdownStoryBook(),
      tags: ["std-dropdown", "std-dropdown-container"],
      example: "tento-ui-js/components/controls/dropdown.example.ts",
      className: "DropdownStoryBook",
    },
    {
      make: () => new InlineSelectStoryBook(),
      tags: ["std-inline-select", "std-inline-select-panel"],
      example: "tento-ui-js/components/controls/inline-select.example.ts",
      className: "InlineSelectStoryBook",
    },
    {
      make: () => new CorePillSelectStoryBook(),
      tags: ["std-pill-select"],
      example: "tento-ui-js/components/controls/pill-select.core.example.ts",
      className: "CorePillSelectStoryBook",
    },
    {
      make: () => new SliderStoryBook(),
      tags: ["std-apple-slider"],
      example: "tento-ui-js/components/controls/slider.example.ts",
      className: "SliderStoryBook",
    },
    {
      make: () => new ThickSliderStoryBook(),
      tags: ["std-thick-slider"],
      example: "tento-ui-js/components/controls/slider.example.ts",
      className: "ThickSliderStoryBook",
    },
    {
      make: () => new SwitchStoryBook(),
      tags: ["std-switch"],
      example: "tento-ui-js/components/controls/switch.example.ts",
      className: "SwitchStoryBook",
    },
    {
      make: () => new CoreTimePickerStoryBook(),
      tags: ["std-time-picker"],
      example: "tento-ui-js/components/controls/time-picker.core.example.ts",
      className: "CoreTimePickerStoryBook",
    },
    {
      make: () => new TwoWaySliderStoryBook(),
      tags: ["std-two-way-slider"],
      example: "tento-ui-js/components/controls/two-way-slider.example.ts",
      className: "TwoWaySliderStoryBook",
    },
    {
      make: () => new ThickTwoWaySliderStoryBook(),
      tags: ["std-thick-two-way-slider"],
      example: "tento-ui-js/components/controls/two-way-slider.example.ts",
      className: "ThickTwoWaySliderStoryBook",
    },
    {
      make: () => new AvatarEditableStoryBook(),
      tags: ["std-editable-avatar", "std-avatar-editable-badge"],
      example: "tento-ui-js/components/core/avatar-editable.example.ts",
      className: "AvatarEditableStoryBook",
    },
    {
      make: () => new CoreJsonViewerStoryBook(),
      tags: ["std-json-viewer"],
      example: "tento-ui-js/components/data/json-viewer.core.example.ts",
      className: "CoreJsonViewerStoryBook",
    },
    {
      make: () => new DateRangeInputStoryBook(),
      tags: ["std-date-range-input"],
      example: "tento-ui-js/components/date-range-input/date-range-input.example.ts",
      className: "DateRangeInputStoryBook",
    },
    {
      make: () => new DiagnosticStoryBook(),
      tags: ["std-diagnostic"],
      example: "tento-ui-js/components/diagnostic.example.ts",
      className: "DiagnosticStoryBook",
    },
    {
      make: () => new DialogStoryBook(),
      tags: ["std-dialog"],
      example: "tento-ui-js/components/dialog/dialog.example.ts",
      className: "DialogStoryBook",
    },
    {
      make: () => new CoreDisclaimerStoryBook(),
      tags: ["std-disclaimer"],
      example: "tento-ui-js/components/disclaimer.core.example.ts",
      className: "CoreDisclaimerStoryBook",
    },
    {
      make: () => new DividerLineStoryBook(),
      tags: ["std-divider"],
      example: "tento-ui-js/components/divider-line/divider-line.example.ts",
      className: "DividerLineStoryBook",
    },
    {
      make: () => new DrawerStoryBook(),
      tags: ["std-drawer"],
      example: "tento-ui-js/components/drawer.example.ts",
      className: "DrawerStoryBook",
    },
    {
      make: () => new EditableTextStoryBook(),
      tags: ["std-editable-text"],
      example: "tento-ui-js/components/editable-text.example.ts",
      className: "EditableTextStoryBook",
    },
    {
      make: () => new EmptyStateStoryBook(),
      tags: ["std-empty-state"],
      example: "tento-ui-js/components/empty-state/empty-state.example.ts",
      className: "EmptyStateStoryBook",
    },
    {
      make: () => new ExceptionTraceStoryBook(),
      tags: ["std-exception-trace"],
      example: "tento-ui-js/components/exception/exception-trace.example.ts",
      className: "ExceptionTraceStoryBook",
    },
    {
      make: () => new ExceptionStoryBook(),
      tags: ["std-exception"],
      example: "tento-ui-js/components/exception/exception.example.ts",
      className: "ExceptionStoryBook",
    },
    {
      make: () => new FacepileStoryBook(),
      tags: ["std-facepile"],
      example: "tento-ui-js/components/facepile.example.ts",
      className: "FacepileStoryBook",
    },
    {
      make: () => new FileInputStoryBook(),
      tags: ["std-file-input"],
      example: "tento-ui-js/components/file-input/file-input.example.ts",
      className: "FileInputStoryBook",
    },
    {
      make: () => new FlippableCardStoryBook(),
      tags: ["std-flippable-card"],
      example: "tento-ui-js/components/flippable-card.example.ts",
      className: "FlippableCardStoryBook",
    },
    {
      make: () => new FlowContainerStoryBook(),
      tags: ["std-flow-container"],
      example: "tento-ui-js/components/flow-container.example.ts",
      className: "FlowContainerStoryBook",
    },
    {
      make: () => new FractionLabelStoryBook(),
      tags: ["std-fraction-label"],
      example: "tento-ui-js/components/fraction-label.example.ts",
      className: "FractionLabelStoryBook",
    },
    {
      make: () => new GridLayoutStoryBook(),
      tags: ["std-grid-layout"],
      example: "tento-ui-js/components/grid/grid-layout.example.ts",
      className: "GridLayoutStoryBook",
    },
    {
      make: () => new HeroLayoutStoryBook(),
      tags: ["std-hero-layout", "std-hero-layout-item"],
      example: "tento-ui-js/components/hero-layout/hero-layout.example.ts",
      className: "HeroLayoutStoryBook",
    },
    {
      make: () => new HoverCardStoryBook(),
      tags: ["std-hover-card"],
      example: "tento-ui-js/components/hover-card/hover-card.example.ts",
      className: "HoverCardStoryBook",
    },
    {
      make: () => new HtmlEditorStoryBook(),
      tags: ["std-html-editor"],
      example: "tento-ui-js/components/html-editor.example.ts",
      className: "HtmlEditorStoryBook",
    },
    {
      make: () => new IconButtonStoryBook(),
      tags: ["std-icon-button"],
      example: "tento-ui-js/components/icon-button.example.ts",
      className: "IconButtonStoryBook",
    },
    {
      make: () => new IconStoryBook(),
      tags: ["std-icon"],
      example: "tento-ui-js/components/icon/icon.example.ts",
      className: "IconStoryBook",
    },
    {
      make: () => new CardIconStoryBook(),
      tags: ["std-calendar-icon"],
      example: "tento-ui-js/components/icons/card-icon.example.ts",
      className: "CardIconStoryBook",
    },
    {
      make: () => new ChartIconStoryBook(),
      tags: ["std-chart-icon"],
      example: "tento-ui-js/components/icons/chart-icon.example.ts",
      className: "ChartIconStoryBook",
    },
    {
      make: () => new ChatIconStoryBook(),
      tags: ["std-chat-icon"],
      example: "tento-ui-js/components/icons/chat-icon.example.ts",
      className: "ChatIconStoryBook",
    },
    {
      make: () => new GlobeIconStoryBook(),
      tags: ["std-globe-icon"],
      example: "tento-ui-js/components/icons/globe-icon.example.ts",
      className: "GlobeIconStoryBook",
    },
    {
      make: () => new HeartIconStoryBook(),
      tags: ["std-heart-icon"],
      example: "tento-ui-js/components/icons/heart-icon.example.ts",
      className: "HeartIconStoryBook",
    },
    {
      make: () => new LinkIconStoryBook(),
      tags: ["std-link-icon"],
      example: "tento-ui-js/components/icons/link-icon.example.ts",
      className: "LinkIconStoryBook",
    },
    {
      make: () => new PomodoroIconStoryBook(),
      tags: ["std-pomodoro-icon"],
      example: "tento-ui-js/components/icons/pomodoro-icon.example.ts",
      className: "PomodoroIconStoryBook",
    },
    {
      make: () => new SearchIconStoryBook(),
      tags: ["std-search-icon"],
      example: "tento-ui-js/components/icons/search-icon.example.ts",
      className: "SearchIconStoryBook",
    },
    {
      make: () => new SheetsIconStoryBook(),
      tags: ["std-sheets-icon"],
      example: "tento-ui-js/components/icons/sheets-icon.example.ts",
      className: "SheetsIconStoryBook",
    },
    {
      make: () => new StickerIconStoryBook(),
      tags: ["std-sticker-icon"],
      example: "tento-ui-js/components/icons/sticker-icon.example.ts",
      className: "StickerIconStoryBook",
    },
    {
      make: () => new TasksIconStoryBook(),
      tags: ["std-tasks-icon"],
      example: "tento-ui-js/components/icons/tasks-icon.example.ts",
      className: "TasksIconStoryBook",
    },
    {
      make: () => new ThemePickerIconStoryBook(),
      tags: ["std-theme-picker-icon"],
      example: "tento-ui-js/components/icons/theme-picker-icon.example.ts",
      className: "ThemePickerIconStoryBook",
    },
    {
      make: () => new TildeIconStoryBook(),
      tags: ["std-tilde-icon"],
      example: "tento-ui-js/components/icons/tilde-icon.example.ts",
      className: "TildeIconStoryBook",
    },
    {
      make: () => new LazyImageStoryBook(),
      tags: ["std-lazy-image"],
      example: "tento-ui-js/components/image/lazy-image.example.ts",
      className: "LazyImageStoryBook",
    },
    {
      make: () => new InputGroupStoryBook(),
      tags: ["std-input-group"],
      example: "tento-ui-js/components/input-group/input-group.example.ts",
      className: "InputGroupStoryBook",
    },
    {
      make: () => new CodeInputStoryBook(),
      tags: ["std-code-input"],
      example: "tento-ui-js/components/input/code-input.example.ts",
      className: "CodeInputStoryBook",
    },
    {
      make: () => new CoreColorFieldStoryBook(),
      tags: ["std-color-field"],
      example: "tento-ui-js/components/input/color-field.core.example.ts",
      className: "CoreColorFieldStoryBook",
    },
    {
      make: () => new ColorInputStoryBook(),
      tags: ["std-color-input"],
      example: "tento-ui-js/components/input/color-input.example.ts",
      className: "ColorInputStoryBook",
    },
    {
      make: () => new DateFieldStoryBook(),
      tags: ["std-date-field", "std-date-field-dropdown"],
      example: "tento-ui-js/components/input/date-field.example.ts",
      className: "DateFieldStoryBook",
    },
    {
      make: () => new DateInputStoryBook(),
      tags: ["std-date-input"],
      example: "tento-ui-js/components/input/date-input.example.ts",
      className: "DateInputStoryBook",
    },
    {
      make: () => new DatePickerInputStoryBook(),
      tags: ["std-date-picker-input"],
      example: "tento-ui-js/components/input/date-picker-input.example.ts",
      className: "DatePickerInputStoryBook",
    },
    {
      make: () => new CoreDatePickerModalStoryBook(),
      tags: ["std-date-picker-modal"],
      example: "tento-ui-js/components/input/date-picker-modal.core.example.ts",
      className: "CoreDatePickerModalStoryBook",
    },
    {
      make: () => new DateTimeRegionInputStoryBook(),
      tags: ["std-datetimeregion-input"],
      example: "tento-ui-js/components/input/datetimeregion-input.example.ts",
      className: "DateTimeRegionInputStoryBook",
    },
    {
      make: () => new CoreDropdownInputStoryBook(),
      tags: ["std-dropdown-input"],
      example: "tento-ui-js/components/input/dropdown-input.core.example.ts",
      className: "CoreDropdownInputStoryBook",
    },
    {
      make: () => new FormStoryBook(),
      tags: ["std-form"],
      example: "tento-ui-js/components/input/form.example.ts",
      className: "FormStoryBook",
    },
    {
      make: () => new HtmlEditorInputStoryBook(),
      tags: ["std-html-editor-input"],
      example: "tento-ui-js/components/input/html-editor-input.example.ts",
      className: "HtmlEditorInputStoryBook",
    },
    {
      make: () => new CoreHtmlEditorModalStoryBook(),
      tags: ["std-html-editor-modal"],
      example: "tento-ui-js/components/input/html-editor-modal.core.example.ts",
      className: "CoreHtmlEditorModalStoryBook",
    },
    {
      make: () => new InputLayoutStoryBook(),
      tags: ["std-input-layout"],
      example: "tento-ui-js/components/input/input-layout.example.ts",
      className: "InputLayoutStoryBook",
    },
    {
      make: () => new NumberInputAccessoryStoryBook(),
      tags: ["std-number-input-accessory"],
      example: "tento-ui-js/components/input/number-input-accessory.example.ts",
      className: "NumberInputAccessoryStoryBook",
    },
    {
      make: () => new CoreNumberInputStoryBook(),
      tags: ["std-number-input"],
      example: "tento-ui-js/components/input/number-input.core.example.ts",
      className: "CoreNumberInputStoryBook",
    },
    {
      make: () => new PropertyListStoryBook(),
      tags: ["std-property-list", "std-property-list-item"],
      example: "tento-ui-js/components/input/property-list.example.ts",
      className: "PropertyListStoryBook",
    },
    {
      make: () => new CoreRadioButtonStoryBook(),
      tags: ["std-radio-button"],
      example: "tento-ui-js/components/input/radio-button.core.example.ts",
      className: "CoreRadioButtonStoryBook",
    },
    {
      make: () => new SelectInputStoryBook(),
      tags: ["std-select-input"],
      example: "tento-ui-js/components/input/select-input.example.ts",
      className: "SelectInputStoryBook",
    },
    {
      make: () => new SliderInputStoryBook(),
      tags: ["std-slider-input"],
      example: "tento-ui-js/components/input/slider-input.example.ts",
      className: "SliderInputStoryBook",
    },
    {
      make: () => new TextAlignmentInputStoryBook(),
      tags: ["std-text-alignment-input"],
      example: "tento-ui-js/components/input/text-alignment-input.example.ts",
      className: "TextAlignmentInputStoryBook",
    },
    {
      make: () => new TextInputMenubarStoryBook(),
      tags: ["std-text-input-menubar"],
      example: "tento-ui-js/components/input/text-input-menubar.example.ts",
      className: "TextInputMenubarStoryBook",
    },
    {
      make: () => new TextInputStoryBook(),
      tags: ["std-text-input"],
      example: "tento-ui-js/components/input/text-input.example.ts",
      className: "TextInputStoryBook",
    },
    {
      make: () => new TimeFieldStoryBook(),
      tags: ["std-time-field", "std-time-field-dropdown"],
      example: "tento-ui-js/components/input/time-field.example.ts",
      className: "TimeFieldStoryBook",
    },
    {
      make: () => new TimeInputStoryBook(),
      tags: ["std-time-input"],
      example: "tento-ui-js/components/input/time-input.example.ts",
      className: "TimeInputStoryBook",
    },
    {
      make: () => new KbdStoryBook(),
      tags: ["std-kbd"],
      example: "tento-ui-js/components/kbd/kbd.example.ts",
      className: "KbdStoryBook",
    },
    {
      make: () => new LibraryCollectionLayoutStoryBook(),
      tags: ["std-library-collection-layout"],
      example: "tento-ui-js/components/library/library-collection-layout.example.ts",
      className: "LibraryCollectionLayoutStoryBook",
    },
    {
      make: () => new LibraryFilterSortRowStoryBook(),
      tags: ["std-library-filter-sort-row"],
      example: "tento-ui-js/components/library/library-filter-sort-row.example.ts",
      className: "LibraryFilterSortRowStoryBook",
    },
    {
      make: () => new LibraryItemPresentationStoryBook(),
      tags: ["std-library-item-presentation"],
      example: "tento-ui-js/components/library/library-item-presentation.example.ts",
      className: "LibraryItemPresentationStoryBook",
    },
    {
      make: () => new LibraryPageShellStoryBook(),
      tags: ["std-library-page-shell"],
      example: "tento-ui-js/components/library/library-page-shell.example.ts",
      className: "LibraryPageShellStoryBook",
    },
    {
      make: () => new LibrarySearchMountStoryBook(),
      tags: ["std-library-search-mount"],
      example: "tento-ui-js/components/library/library-search-mount.example.ts",
      className: "LibrarySearchMountStoryBook",
    },
    {
      make: () => new LibraryToolbarStoryBook(),
      tags: ["std-library-toolbar"],
      example: "tento-ui-js/components/library/library-toolbar.example.ts",
      className: "LibraryToolbarStoryBook",
    },
    {
      make: () => new LightboxStoryBook(),
      tags: ["std-lightbox"],
      example: "tento-ui-js/components/lightbox/lightbox.example.ts",
      className: "LightboxStoryBook",
    },
    {
      make: () => new LinkEditPopoverStoryBook(),
      tags: ["std-link-edit-popover"],
      example: "tento-ui-js/components/link-edit-popover.example.ts",
      className: "LinkEditPopoverStoryBook",
    },
    {
      make: () => new LinkTextStoryBook(),
      tags: ["std-link"],
      example: "tento-ui-js/components/link-text/link-text.example.ts",
      className: "LinkTextStoryBook",
    },
    {
      make: () => new CoreListCellLayoutStoryBook(),
      tags: ["std-list-cell-layout"],
      example: "tento-ui-js/components/list/list-cell-layout.core.example.ts",
      className: "CoreListCellLayoutStoryBook",
    },
    {
      make: () => new ListStoryBook(),
      tags: ["std-list"],
      example: "tento-ui-js/components/list/list.example.ts",
      className: "ListStoryBook",
    },
    {
      make: () => new MarkdownStoryBook(),
      tags: ["std-markdown"],
      example: "tento-ui-js/components/markdown/markdown.example.ts",
      className: "MarkdownStoryBook",
    },
    {
      make: () => new MenuBarStoryBook(),
      tags: ["std-menu-bar"],
      example: "tento-ui-js/components/menu-bar/menu-bar.example.ts",
      className: "MenuBarStoryBook",
    },
    {
      make: () => new MiniWindowStoryBook(),
      tags: ["std-mini-window"],
      example: "tento-ui-js/components/mini-window.example.ts",
      className: "MiniWindowStoryBook",
    },
    {
      make: () => new CoreModalCloseButtonStoryBook(),
      tags: ["std-modal-close-button"],
      example: "tento-ui-js/components/modal-close-button/modal-close-button.core.example.ts",
      className: "CoreModalCloseButtonStoryBook",
    },
    {
      make: () => new MultiSelectStoryBook(),
      tags: ["std-multi-select"],
      example: "tento-ui-js/components/multi-select/multi-select.example.ts",
      className: "MultiSelectStoryBook",
    },
    {
      make: () => new NumberFieldStoryBook(),
      tags: ["std-number-field"],
      example: "tento-ui-js/components/number-field/number-field.example.ts",
      className: "NumberFieldStoryBook",
    },
    {
      make: () => new OutlineStoryBook(),
      tags: ["std-outline"],
      example: "tento-ui-js/components/outline/outline.example.ts",
      className: "OutlineStoryBook",
    },
    {
      make: () => new OverflowListStoryBook(),
      tags: ["std-overflow-list"],
      example: "tento-ui-js/components/overflow-list/overflow-list.example.ts",
      className: "OverflowListStoryBook",
    },
    {
      make: () => new PageIndicatorDotsStoryBook(),
      tags: ["std-page-indicator-dots"],
      example: "tento-ui-js/components/page-indicator-dots.example.ts",
      className: "PageIndicatorDotsStoryBook",
    },
    {
      make: () => new PaginationStoryBook(),
      tags: ["std-pagination"],
      example: "tento-ui-js/components/pagination/pagination.example.ts",
      className: "PaginationStoryBook",
    },
    {
      make: () => new PillButtonStoryBook(),
      tags: ["std-pill-button"],
      example: "tento-ui-js/components/pill-button.example.ts",
      className: "PillButtonStoryBook",
    },
    {
      make: () => new PillTextInputStoryBook(),
      tags: ["std-pill-text-input"],
      example: "tento-ui-js/components/pill-text-input.example.ts",
      className: "PillTextInputStoryBook",
    },
    {
      make: () => new PlotStoryBook(),
      tags: ["std-plot", "std-plot-tooltip"],
      example: "tento-ui-js/components/plot.example.ts",
      className: "PlotStoryBook",
    },
    {
      make: () => new PopoverStoryBook(),
      tags: ["std-popover"],
      example: "tento-ui-js/components/popover/popover.example.ts",
      className: "PopoverStoryBook",
    },
    {
      make: () => new ProgressBarStoryBook(),
      tags: ["std-progress-bar"],
      example: "tento-ui-js/components/progress-bar/progress-bar.example.ts",
      className: "ProgressBarStoryBook",
    },
    {
      make: () => new PromptStoryBook(),
      tags: ["std-prompt", "std-prompt-layout"],
      example: "tento-ui-js/components/prompt.example.ts",
      className: "PromptStoryBook",
    },
    {
      make: () => new PromptAlertStoryBook(),
      tags: ["std-prompt-alert"],
      example: "tento-ui-js/components/prompt.example.ts",
      className: "PromptAlertStoryBook",
    },
    {
      make: () => new ProseMirrorStoryBook(),
      tags: ["std-prosemirror"],
      example: "tento-ui-js/components/prosemirror.example.ts",
      className: "ProseMirrorStoryBook",
    },
    {
      make: () => new RadioButtonCellStoryBook(),
      tags: ["std-radio-button-cell"],
      example: "tento-ui-js/components/radio-button-cell.example.ts",
      className: "RadioButtonCellStoryBook",
    },
    {
      make: () => new RadioListStoryBook(),
      tags: ["std-radio-list"],
      example: "tento-ui-js/components/radio-list/radio-list.example.ts",
      className: "RadioListStoryBook",
    },
    {
      make: () => new CoreRailNavStoryBook(),
      tags: ["std-rail-nav"],
      example: "tento-ui-js/components/rail/rail-nav.core.example.ts",
      className: "CoreRailNavStoryBook",
    },
    {
      make: () => new CoreRailSectionStoryBook(),
      tags: ["std-rail-section"],
      example: "tento-ui-js/components/rail/rail-section.core.example.ts",
      className: "CoreRailSectionStoryBook",
    },
    {
      make: () => new CoreRailStoryBook(),
      tags: ["std-rail"],
      example: "tento-ui-js/components/rail/rail.core.example.ts",
      className: "CoreRailStoryBook",
    },
    {
      make: () => new RecordHeaderStoryBook(),
      tags: ["std-record-header"],
      example: "tento-ui-js/components/record-header.example.ts",
      className: "RecordHeaderStoryBook",
    },
    {
      make: () => new ResizeHandleStoryBook(),
      tags: ["std-resize-handle"],
      example: "tento-ui-js/components/resize-handle/resize-handle.example.ts",
      className: "ResizeHandleStoryBook",
    },
    {
      make: () => new SectionTabsStoryBook(),
      tags: ["std-section-tabs"],
      example: "tento-ui-js/components/review/section-tabs.example.ts",
      className: "SectionTabsStoryBook",
    },
    {
      make: () => new RichTextEditorStoryBook(),
      tags: ["std-rich-text-editor"],
      example: "tento-ui-js/components/rich-text-editor/rich-text-editor.example.ts",
      className: "RichTextEditorStoryBook",
    },
    {
      make: () => new RoundStoryBook(),
      tags: ["std-round"],
      example: "tento-ui-js/components/round.example.ts",
      className: "RoundStoryBook",
    },
    {
      make: () => new CartesianCoordinateStoryBook(),
      tags: ["std-cc", "std-cc-axis", "std-cc-line", "std-cc-point", "std-cc-segment"],
      example: "tento-ui-js/components/scroll/cartesian-coordinate.example.ts",
      className: "CartesianCoordinateStoryBook",
    },
    {
      make: () => new ScrollHorizontalStoryBook(),
      tags: ["std-scroll-horizontal"],
      example: "tento-ui-js/components/scroll/scroll-horizontal.example.ts",
      className: "ScrollHorizontalStoryBook",
    },
    {
      make: () => new ScrollLayoutSnapshotOverlayStoryBook(),
      tags: ["std-scroll-layout-snapshot-overlay"],
      example: "tento-ui-js/components/scroll/scroll-layout-snapshot-overlay.example.ts",
      className: "ScrollLayoutSnapshotOverlayStoryBook",
    },
    {
      make: () => new SectionHeadStoryBook(),
      tags: ["std-section-head"],
      example: "tento-ui-js/components/section-head.example.ts",
      className: "SectionHeadStoryBook",
    },
    {
      make: () => new SegmentedControlStoryBook(),
      tags: ["std-segmented-control"],
      example: "tento-ui-js/components/segmented-control/segmented-control.example.ts",
      className: "SegmentedControlStoryBook",
    },
    {
      make: () => new SettingsSectionStoryBook(),
      tags: ["std-settings-section"],
      example: "tento-ui-js/components/settings/settings.core.example.ts",
      className: "SettingsSectionStoryBook",
    },
    {
      make: () => new SettingsRowStoryBook(),
      tags: ["std-settings-row"],
      example: "tento-ui-js/components/settings/settings.core.example.ts",
      className: "SettingsRowStoryBook",
    },
    {
      make: () => new SettingsBodyStoryBook(),
      tags: ["std-settings-body"],
      example: "tento-ui-js/components/settings/settings.core.example.ts",
      className: "SettingsBodyStoryBook",
    },
    {
      make: () => new SettingsSummaryStoryBook(),
      tags: ["std-settings-summary"],
      example: "tento-ui-js/components/settings/settings.core.example.ts",
      className: "SettingsSummaryStoryBook",
    },
    {
      make: () => new AppBarStoryBook(),
      tags: ["std-app-bar"],
      example: "tento-ui-js/components/shell-layout/app-bar.example.ts",
      className: "AppBarStoryBook",
    },
    {
      make: () => new SideNavStoryBook(),
      tags: ["std-side-nav"],
      example: "tento-ui-js/components/side-nav/side-nav.example.ts",
      className: "SideNavStoryBook",
    },
    {
      make: () => new CoreSidebarActionBarStoryBook(),
      tags: ["std-sidebar-action-bar"],
      example: "tento-ui-js/components/sidebar/sidebar-action-bar.core.example.ts",
      className: "CoreSidebarActionBarStoryBook",
    },
    {
      make: () => new SidebarContainerStoryBook(),
      tags: ["std-sidebar-container"],
      example: "tento-ui-js/components/sidebar/sidebar-container.example.ts",
      className: "SidebarContainerStoryBook",
    },
    {
      make: () => new SidebarExpandButtonStoryBook(),
      tags: ["std-sidebar-expand-button"],
      example: "tento-ui-js/components/sidebar/sidebar-expand-button.example.ts",
      className: "SidebarExpandButtonStoryBook",
    },
    {
      make: () => new CoreSidebarSectionContainerStoryBook(),
      tags: ["std-sidebar-section-container"],
      example: "tento-ui-js/components/sidebar/sidebar-section-container.core.example.ts",
      className: "CoreSidebarSectionContainerStoryBook",
    },
    {
      make: () => new CoreSidebarSectionNavStoryBook(),
      tags: ["std-sidebar-section-nav"],
      example: "tento-ui-js/components/sidebar/sidebar-section-nav.core.example.ts",
      className: "CoreSidebarSectionNavStoryBook",
    },
    {
      make: () => new CoreSidebarSectionStoryBook(),
      tags: ["std-sidebar-section"],
      example: "tento-ui-js/components/sidebar/sidebar-section.core.example.ts",
      className: "CoreSidebarSectionStoryBook",
    },
    {
      make: () => new SkeletonStoryBook(),
      tags: ["std-skeleton"],
      example: "tento-ui-js/components/skeleton/skeleton.example.ts",
      className: "SkeletonStoryBook",
    },
    {
      make: () => new SpinnerStoryBook(),
      tags: ["std-spinner"],
      example: "tento-ui-js/components/spinner/spinner.example.ts",
      className: "SpinnerStoryBook",
    },
    {
      make: () => new SplitButtonsStoryBook(),
      tags: ["std-split-buttons"],
      example: "tento-ui-js/components/split-buttons/split-buttons.example.ts",
      className: "SplitButtonsStoryBook",
    },
    {
      make: () => new SpotlightLayoutStoryBook(),
      tags: ["std-spotlight-layout"],
      example: "tento-ui-js/components/spotlight/spotlight-layout.example.ts",
      className: "SpotlightLayoutStoryBook",
    },
    {
      make: () => new CoreSpotlightRowStoryBook(),
      tags: ["std-spotlight-row"],
      example: "tento-ui-js/components/spotlight/spotlight-row.core.example.ts",
      className: "CoreSpotlightRowStoryBook",
    },
    {
      make: () => new SquircleStoryBook(),
      tags: ["std-squircle"],
      example: "tento-ui-js/components/squircle/squircle.example.ts",
      className: "SquircleStoryBook",
    },
    {
      make: () => new StatusMarkStoryBook(),
      tags: ["std-status-mark"],
      example: "tento-ui-js/components/status/status-mark.example.ts",
      className: "StatusMarkStoryBook",
    },
    {
      make: () => new CoreStepperHorizontalStoryBook(),
      tags: ["std-stepper-horizontal"],
      example: "tento-ui-js/components/stepper.core.example.ts",
      className: "CoreStepperHorizontalStoryBook",
    },
    {
      make: () => new StepperStoryBook(),
      tags: ["std-stepper"],
      example: "tento-ui-js/components/stepper.example.ts",
      className: "StepperStoryBook",
    },
    {
      make: () => new SwatchRowStoryBook(),
      tags: ["std-swatch-row"],
      example: "tento-ui-js/components/swatch-row/swatch-row.example.ts",
      className: "SwatchRowStoryBook",
    },
    {
      make: () => new TableFooterStoryBook(),
      tags: ["std-table-footer"],
      example: "tento-ui-js/components/table/table-footer.example.ts",
      className: "TableFooterStoryBook",
    },
    {
      make: () => new TableStoryBook(),
      tags: ["std-table", "std-table-header", "std-table-header-column", "std-table-body", "std-table-body-row"],
      example: "tento-ui-js/components/table/table.example.ts",
      className: "TableStoryBook",
    },
    {
      make: () => new TextAreaStoryBook(),
      tags: ["std-text-area"],
      example: "tento-ui-js/components/text-area/text-area.example.ts",
      className: "TextAreaStoryBook",
    },
    {
      make: () => new ThemeContextStoryBook(),
      tags: ["std-theme-context"],
      example: "tento-ui-js/components/theme-context/theme-context.example.ts",
      className: "ThemeContextStoryBook",
    },
    {
      make: () => new ThumbnailStoryBook(),
      tags: ["std-thumbnail"],
      example: "tento-ui-js/components/thumbnail/thumbnail.example.ts",
      className: "ThumbnailStoryBook",
    },
    {
      make: () => new TimestampStoryBook(),
      tags: ["std-timestamp"],
      example: "tento-ui-js/components/timestamp/timestamp.example.ts",
      className: "TimestampStoryBook",
    },
    {
      make: () => new ToastStoryBook(),
      tags: ["std-toast"],
      example: "tento-ui-js/components/toast/toast.example.ts",
      className: "ToastStoryBook",
    },
    {
      make: () => new CoreToasterStoryBook(),
      tags: ["std-toaster"],
      example: "tento-ui-js/components/toast/toaster.core.example.ts",
      className: "CoreToasterStoryBook",
    },
    {
      make: () => new CoreToasterPersistentContainerStoryBook(),
      tags: ["std-toaster-persistent-container"],
      example: "tento-ui-js/components/toast/toaster.core.example.ts",
      className: "CoreToasterPersistentContainerStoryBook",
    },
    {
      make: () => new ToggleButtonGroupStoryBook(),
      tags: ["std-toggle-button-group"],
      example: "tento-ui-js/components/toggle-button/toggle-button-group.example.ts",
      className: "ToggleButtonGroupStoryBook",
    },
    {
      make: () => new ToggleButtonStoryBook(),
      tags: ["std-toggle-button"],
      example: "tento-ui-js/components/toggle-button/toggle-button.example.ts",
      className: "ToggleButtonStoryBook",
    },
    {
      make: () => new TokenInputStoryBook(),
      tags: ["std-token-input"],
      example: "tento-ui-js/components/token/token-input.example.ts",
      className: "TokenInputStoryBook",
    },
    {
      make: () => new TokenStoryBook(),
      tags: ["std-token"],
      example: "tento-ui-js/components/token/token.example.ts",
      className: "TokenStoryBook",
    },
    {
      make: () => new ToolbarStoryBook(),
      tags: ["std-toolbar"],
      example: "tento-ui-js/components/toolbar/toolbar.example.ts",
      className: "ToolbarStoryBook",
    },
    {
      make: () => new TooltipStoryBook(),
      tags: ["std-tooltip"],
      example: "tento-ui-js/components/tooltip/tooltip.example.ts",
      className: "TooltipStoryBook",
    },
    {
      make: () => new TopNavStoryBook(),
      tags: ["std-top-nav"],
      example: "tento-ui-js/components/top-nav/top-nav.example.ts",
      className: "TopNavStoryBook",
    },
    {
      make: () => new TransitionStoryBook(),
      tags: ["std-transition"],
      example: "tento-ui-js/components/transition.example.ts",
      className: "TransitionStoryBook",
    },
    {
      make: () => new TreeListStoryBook(),
      tags: ["std-tree-list"],
      example: "tento-ui-js/components/tree-list/tree-list.example.ts",
      className: "TreeListStoryBook",
    },
    {
      make: () => new TypeaheadStoryBook(),
      tags: ["std-typeahead"],
      example: "tento-ui-js/components/typeahead/typeahead.example.ts",
      className: "TypeaheadStoryBook",
    },
    {
      make: () => new VisuallyHiddenStoryBook(),
      tags: ["std-visually-hidden"],
      example: "tento-ui-js/components/visually-hidden/visually-hidden.example.ts",
      className: "VisuallyHiddenStoryBook",
    },
  ];
}
